import React, { forwardRef } from 'react';

import MUIDialogTitle, {
  DialogTitleProps as MUIDialogTitleProps,
} from '@material-ui/core/DialogTitle';

interface DialogTitleProps extends MUIDialogTitleProps {}

const DialogTitle = forwardRef<HTMLDivElement, DialogTitleProps>(
  (props, ref) => {
    return (
      <MUIDialogTitle {...props} ref={ref}>
        {props.children}
      </MUIDialogTitle>
    );
  }
);

DialogTitle.displayName = 'DialogTitle';

export default DialogTitle;
